// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__B0_vu","icon":"style_icon__3koVL","setIcon":"style_setIcon__IKOAG","setIconActive":"style_setIconActive__2CLd4","link":"style_link__2Vadu"};